export const API_QUERY_KEYS = {
  addressSuggest: 'addressSuggest',
  addressStreetsForCity: 'addressStreetsForCity',
  addressVerify: 'addressVerify',
  addressResolveStreet: 'addressResolveStreet',
  authConfig: 'authConfig',
  authHint: 'authHint',
  autoReminders: 'autoReminders',
  board: 'board',
  boardGroups: 'boardGroups',
  boardForms: 'boardForms',
  boardInvitation: 'boardInvitation',
  boardInvitations: 'boardInvitations',
  boardQueue: 'boardQueue',
  boardQueueGroups: 'boardQueueGroups',
  boardTemplates: 'boardTemplates',
  boardUsers: 'boardUsers',
  companiesList: 'companiesList',
  companyDataFromGus: 'companyDataFromGus',
  companyGroups: 'companyGroups',
  dataSources: 'dataSources',
  dataSourcesSearch: 'dataSourcesSearch',
  dataStream: 'dataStream',
  dataStreams: 'dataStreams',
  dataType: 'dataType',
  dataTypes: 'dataTypes',
  defaultQueueWorkflow: 'defaultQueueWorkflow',
  documentInvitation: 'documentInvitation',
  document: 'document',
  documentCollection: 'documentCollection',
  documentQueueCollection: 'documentQueueCollection',
  documentQueueGroupsCollection: 'documentQueueGroupsCollection',
  documentComments: 'documentComments',
  documentPages: 'documentPages',
  documentPdf: 'documentPdf',
  documents: 'documents',
  documentsAttachments: 'documentsAttachments',
  documentsExternalFiles: 'documentsExternalFiles',
  documentsQueue: 'documentsQueue',
  documentsQueueGroups: 'documentsQueueGroups',
  documentsUserRoles: 'documentsUserRoles',
  documentsVersions: 'documentsVersions',
  documentsVersionsData: 'documentsVersionsData',
  documentsSignaturePosition: 'documentsSignaturePosition',
  features: 'features',
  externalLetterheadFile: 'externalLetterheadFile',
  externalTransactionEntryDebug: 'externalTransactionEntryDebug',
  extForm: 'extForm',
  form: 'form',
  formAttachments: 'formAttachments',
  formsOptions: 'formsOptions',
  invitationAuth: 'invitationAuth',
  invitationAuthOtp: 'invitationAuthOtp',
  notificationHint: 'notificationHint',
  notifications: 'notifications',
  offers: 'offers',
  organisation: 'organisation',
  organisationCustomizationsDocument: 'organisationCustomizationsDocument',
  organisationCustomizationsEmail: 'organisationCustomizationsEmail',
  organisationCustomizationsEmailPreview:
    'organisationCustomizationsEmailPreview',
  organisationBoards: 'organisationBoards',
  organisationTemplates: 'organisationTemplates',
  organisationUsers: 'organisationUsers',
  organisations: 'organisations',
  otpCode: 'otpCode',
  postCompany: 'postCompany',
  registryCourts: 'registryCourts',
  signiusCountries: 'signiusCountries',
  signiusLanguages: 'signiusLanguages',
  signiusStatus: 'signiusStatus',
  signiusCertificate: 'signiusCertificate',
  signiusVerificationUrl: 'signiusVerificationUrl',
  sso: 'sso',
  ssoAuth: 'ssoAuth',
  taxOffices: 'taxOffices',
  technicalUser: 'technicalUser',
  technicalUsers: 'technicalUsers',
  template: 'template',
  templateVersion: 'templateVersion',
  templateVersions: 'templateVersions',
  transaction: 'transaction',
  transactionDataStream: 'transactionDataStream',
  transactionDataType: 'transactionDataType',
  transactionEntries: 'transactionEntries',
  transactionEntry: 'transactionEntry',
  transactionEntryDebug: 'transactionEntryDebug',
  transactions: 'transactions',
  user: 'user',
  userBoards: 'userBoards',
  userNotifications: 'userNotifications',
  webhooks: 'webhooks',
  webhooksLogs: 'webhooksLogs',
  zealidSession: 'zealidSession',
};
